import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { PublicShell, PublicError } from "@/components/PublicShell";
import { TypeGallery } from "@/pages/OccupancyPlan";
import { BannerGallery } from "@/components/banner/BannerGallery";

export default function PublicGallery() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [type, setType] = useState("");
  useEffect(() => {
    api.get(`/public/gallery/${token}`).then((r) => setData(r.data)).catch((e) => setErr(e.response?.data?.detail || "Dieser Link ist ungültig."));
  }, [token]);
  const previewPath = useCallback((g) => `/public/gallery/${token}/preview/${g.id}`, [token]);
  const videoPath = useCallback((g) => `/public/gallery/${token}/video/${g.id}`, [token]);
  const bannerPreview = useCallback((gid) => `/public/gallery/${token}/preview/${gid}`, [token]);
  if (err) return <PublicShell><PublicError text={err} /></PublicShell>;
  if (!data) return <PublicShell wide="full"><p className="text-slate-400">Lädt …</p></PublicShell>;
  const deDate = (d) => d.split("-").reverse().join(".");
  return (
    <PublicShell wide="full">
      <div className="space-y-6" data-testid="public-gallery">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Werbeflächen – Galerie</h1>
            <p className="text-slate-500 text-sm mt-1">Stand {deDate(data.today)} · Klick auf eine Grafik zeigt sie groß.</p>
          </div>
          <select value={type} onChange={(e) => setType(e.target.value)} className="h-9 rounded-md border border-slate-200 px-2 text-sm" data-testid="public-gallery-type">
            <option value="">Alle Leistungsarten</option>
            {data.types.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
        </div>
        {data.types.filter((t) => !type || t.id === type).map((t) => (
          <TypeGallery key={t.id} type={t} today={data.today} previewPath={previewPath} videoPath={videoPath} plain />
        ))}
        <BannerGallery banners={data.banners || []} today={data.today} previewPath={bannerPreview} typeId={type} />
      </div>
    </PublicShell>
  );
}
